import type { IncludeBearerTokenCondition } from 'keycloak-angular';
import {
  provideKeycloak,
  createInterceptorCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  AutoRefreshTokenService,
  UserActivityService,
  withAutoRefreshToken,
} from 'keycloak-angular';
import type { EnvironmentProviders } from '@angular/core';
import { environment } from './environment';

const apiCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: environment.apiUrlPattern,
  bearerPrefix: 'Bearer',
});
//Emlékeztető: SSO session idle: 12h, SSO session max: 24h
export const provideKeycloakAngular = (): EnvironmentProviders =>
  provideKeycloak({
    config: environment.keycloakConfig,
    features: [
      withAutoRefreshToken({
        onInactivityTimeout: 'logout',
        sessionTimeout: 12 * 3600000, // 12h
      }),
    ],
    providers: [
      AutoRefreshTokenService,
      UserActivityService,
      {
        provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
        useValue: [apiCondition],
      },
    ],
  });
